import React from 'react'
import { Helmet } from 'react-helmet'
import './notfound.css'

const NotFound = () => (
  <main className="not-found-container1">
    <Helmet><title>404 - Not Found | NuggetCraft SMP</title></Helmet>
    <p className="not-found-code">404</p>
    <h1 className="not-found-text2">Page not found</h1>
    <p className="not-found-text3">The page you requested does not exist or has moved.</p>
    <a className="thq-button-filled" href="/">Return home</a>
  </main>
)

export default NotFound
